
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/providers/shared.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
@Component({
  selector: 'sm-previous-employees',
  templateUrl: './previous-employees.component.html',
  styleUrls: ['./previous-employees.component.scss']
})
export class PreviousEmployeesComponent implements OnInit, OnDestroy {

  messageList: any[] = [];
  employeeData: any = []
  entityHashId: string =''
  public loader: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "date of joining",
      columnProperty: "dateOfJoin"
    },
    {
      columnName: "phone",
      columnProperty: "phone"
    },
   
    {
      columnName: "total sales",
      columnProperty: "totalSales"
    },
  ];
  private _apiSubscription: Subscription;
  clickEventSubscription: Subscription;
  constructor(private sharedService: SharedService, private _apiService: ApiService,private _dialog: MatDialog, private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private loaderservice: LoaderServiceService, private angularFireMessaging: AngularFireMessaging) { 
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
        console.log(resData);
        this.employeeData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            if(element.isExEmployee == 1){
              if(element.is_owner == 0){
                if(element.addressInfo && element.addressInfo!= null && element.addressInfo!= 'null'){
                  element.addressInfo = (JSON.parse(element.addressInfo)).addressLine
                    }

                this.employeeData.push(element)
              }
            }
          });
        }
        this.messageList = resData.result ? resData.result : [];
        
      }
      this.loader = false;
      this.loaderservice.showLoader = false
    });
    // this.loader = false;
  }

  ngOnInit(): void {
    this.loader =true
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.loaderservice.showLoader = true
    this._apiService.getEmployeeList(this.entityHashId);
   
  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  // test(row:any){
  //   console.log(row);
    
  // }

  // viewSubscription(rowvalue:any){
  //   console.log(rowvalue);
  //   this._dialog.open(EmployeeSubscriptionComponent, {
  //     data: JSON.parse(rowvalue),
  //     maxWidth: 500,
  //     panelClass: 'employee-subscription-dialog'
  //   });
  // }


  viewDetails(){
    
  }
 

}
